import React from 'react';
import { Link } from 'react-router-dom';

const CompanySummary = ({ company, onDelete }) => {
  return (
    <div className="col s12 m6">
      <div className="card z-depth-2 project-summary">
        <div className="card-content grey-text text-darken-3">
          <span className="company-country">
            <img alt="" className="company-country-image" src={'images/' + company.countryCode + '.svg'} />
          </span>
          {/*<img alt="banner" className="left banner-image" src={company.bannerUrl} />*/}
          <span className="card-title ">{company.companyName}</span>
          {/*<p className="company-address">{company.address}</p>*/}
          {/* <p className="grey-text">{moment(project.createdAt.toDate()).calendar()}</p> */}
        </div>
        <div className="card-action">
          <Link to={'/company/' + company.id} key={'view_' + company.id}>
            View
          </Link>
          <Link to={'/editCompany/' + company.id} key={'edit_' + company.id}>
            Edit
          </Link>
          <Link to="#" onClick={(e) => onDelete(company.id, company.companyName)} key={'delete_' + company.id}>
            Delete
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CompanySummary;
